import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getHighlightColor } from "../helpers/highlightColor";
import { SDropdown } from "../../../SDropdown";
import { SFlex } from "../../../components";
import tw from "tailwind-styled-components";
import React from "react";
import STooltip from "../../../Tooltip";
import useChildIndex from "../../../hooks/useChildIndex";
export const renderIcon = ({ icon, label, value })=>{
    console.log(`CSSColorPicker -renderIcon `, icon, label);
    if (typeof icon !== "undefined") {
        if (typeof icon === "function") {
            return icon({
                value
            });
        }
        return icon;
    }
    return label;
};
export const CSSEnum = ({ props, onSelectOption, enumOptions })=>{
    console.log(`CSSEnum - enumOptions`, enumOptions, props);
    const { options, option } = enumOptions;
    const orderedOptions = Object.entries(options).map(([value, rest])=>({
            value,
            ...rest
        }));
    const shouldUseDropdown = orderedOptions.length > 6 || orderedOptions.some((x)=>!x.icon);
    if (!shouldUseDropdown) {
        return /*#__PURE__*/ _jsx(CSSEnumButtons, {
            props: props,
            selectedOption: props?.value?.value || undefined,
            onSelectOption: onSelectOption,
            orderedOptions: orderedOptions
        });
    } else {
        return /*#__PURE__*/ _jsx(CSSEnumDropdown, {
            props: props,
            selectedOption: props?.value?.value || undefined,
            onSelectOption: onSelectOption,
            orderedOptions: orderedOptions
        });
    }
};
const CSSEnumDropdown = ({ selectedOption, orderedOptions, onSelectOption, props })=>{
    const literalValueOption = orderedOptions.find((x)=>x.value === selectedOption);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            style: {},
            className: `w-full !h-[26px] !border${(()=>{
                if (!selectedOption) {
                    return "!border-[#4A4F55]";
                }
                if (props.isDynamic) {
                    return "!border-purple-500";
                }
                return "!border-brand-primary border-opacity-10";
            })()} rounded-md`,
            children: /*#__PURE__*/ _jsx(SDropdown, {
                disabled: props.readOnly,
                isUnstyledItems: true,
                position: "left",
                display: "relative",
                className: "!text-opacity-100",
                elements: orderedOptions.map(({ value, label, icon })=>{
                    return /*#__PURE__*/ _jsx(SDropdown.Item, {
                        onClick: ()=>{
                            onSelectOption(value);
                        },
                        $size: "sm",
                        children: renderIcon({
                            icon,
                            label,
                            value
                        })
                    }, value);
                }),
                children: /*#__PURE__*/ _jsx(SDropdown.Button, {
                    $small: true,
                    $full: true,
                    children: literalValueOption ? renderIcon({
                        ...literalValueOption,
                        value: selectedOption || literalValueOption.label
                    }) : "-"
                })
            })
        })
    });
};
const highlightColorToSelection = (highlightColor)=>{
    if (highlightColor === "brand-primary") {
        return "literal";
    }
    if (highlightColor === "purple-500") {
        return "conditional";
    }
    return undefined;
};
const PropertyButtonContainer = tw.div`
  flex
  justify-center
  items-center
  grow
  border
  border-white
  border-opacity-10
  rounded-md
  py-[6px]
  text-xs
  cursor-pointer

  ${({ $selection })=>{
    return $selection ? $selection === "literal" ? "bg-brand-primary bg-opacity-10 text-brand-primary hover:border-opacity-20" : $selection === "conditional" ? "bg-purple-500 bg-opacity-10 text-purple-500 hover:border-opacity-20" : "bg-grayscale-light hover:border-opacity-30 text-white" : "bg-grayscale-light hover:border-opacity-30 text-white";
}}
`;
const PropertyButton = ({ icon, label, value, onClick, selection, showTooltip = true, grow = true })=>{
    const ref = React.useRef(null);
    const { isFirst, isLast } = useChildIndex(ref) || {};
    return /*#__PURE__*/ _jsxs("div", {
        className: grow ? "grow" : "",
        ref: ref,
        children: [
            showTooltip && /*#__PURE__*/ _jsx(STooltip, {
                size: "xs",
                placement: isFirst ? "top-start" : isLast ? "top-end" : "top",
                content: typeof value !== "string" ? label : label || value,
                children: /*#__PURE__*/ _jsx(PropertyButtonContainer, {
                    ref: ref,
                    onClick: ()=>onClick(value),
                    $selection: selection,
                    children: typeof icon === "function" ? icon({
                        value
                    }) : icon
                })
            }),
            !showTooltip && /*#__PURE__*/ _jsx(PropertyButtonContainer, {
                ref: ref,
                onClick: ()=>onClick(value),
                $selection: selection,
                children: typeof icon === "function" ? icon({
                    value
                }) : icon
            })
        ]
    });
};
export default PropertyButton;
const CSSEnumButtons = ({ selectedOption, orderedOptions, onSelectOption, props })=>{
    console.log(`CSSEnumButtons - orderedOptions`, orderedOptions, selectedOption);
    return /*#__PURE__*/ _jsx(SFlex, {
        grow: "1",
        direction: "row",
        gap: "1",
        children: orderedOptions.map(({ value, label, icon })=>{
            const shouldShowSelection = value === selectedOption;
            const highlightColor = getHighlightColor({
                isDynamic: props.isDynamic,
                hasValue: !!selectedOption
            });
            console.log(`CSSEnumButtons - selection - ${selectedOption}`, highlightColor, value);
            return /*#__PURE__*/ _jsx(PropertyButton, {
                label: label,
                value: value,
                icon: icon,
                selection: shouldShowSelection ? props?.isDynamic ? "conditional" : "literal" : undefined,
                onClick: (clickedValue)=>{
                    if (props.readOnly) return;
                    console.log(`CSSEnumButtons - clickedValue`, clickedValue);
                    onSelectOption(clickedValue);
                }
            }, value);
        })
    });
};
